import { ComplementaryProductsComponent } from './complementary-products.component';

export const ComplementaryProducts = ComplementaryProductsComponent;
